(function() {
  let intersectionObserver = null;
  let sentinel = null;
  let isLoading = false;
  let nextPageUrl = null;
  let containerObserver = null;
  let isRestored = false;

  function isBackForwardNavigation() {
    try {
      const entries = performance.getEntriesByType('navigation');
      if (entries.length > 0) {
        return entries[0].type === 'back_forward';
      }
    } catch (e) {}
    try {
      return performance.navigation.type === 2;
    } catch (e) {}
    return false;
  }

  function saveInfiniteScrollState() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    
    const stateKey = `infinite-scroll:${window.location.pathname}${window.location.search}`;
    const state = {
      html: productGrid.innerHTML,
      nextPageUrl: nextPageUrl,
      scrollPosition: window.scrollY
    };
    try {
      sessionStorage.setItem(stateKey, JSON.stringify(state));
    } catch (e) {
      console.error('Failed to save infinite scroll state:', e);
    }
  }

  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const productGrid = document.getElementById('product-grid');
      if (productGrid) {
        const stateKey = `infinite-scroll:${window.location.pathname}${window.location.search}`;
        try {
          let state = {};
          const savedState = sessionStorage.getItem(stateKey);
          if (savedState) {
            state = JSON.parse(savedState);
          } else {
            state.html = productGrid.innerHTML;
            state.nextPageUrl = nextPageUrl;
          }
          state.scrollPosition = window.scrollY;
          sessionStorage.setItem(stateKey, JSON.stringify(state));
        } catch (e) {}
      }
    }, 100);
  });

  function updateProductCount() {
    // No-op: Prevent overriding the total product count with the visible count.
  }

  function triggerProductCountUpdate() {
    // No-op: Prevent triggering count overrides.
  }

  function setupInfiniteScroll() {
    // Clean up existing sentinel if any
    const existingSentinel = document.getElementById('infinite-scroll-sentinel');
    if (existingSentinel) {
      existingSentinel.remove();
    }
    if (intersectionObserver) {
      intersectionObserver.disconnect();
      intersectionObserver = null;
    }

    const productGrid = document.getElementById('product-grid');
    const paginationWrapper = document.querySelector('.pagination-wrapper');

    if (!productGrid || !paginationWrapper) {
      return;
    }

    if (isRestored && !nextPageUrl) {
      // We restored to the end of the pages, hide pagination and exit without sentinel
      paginationWrapper.style.display = 'none';
      isRestored = false;
      return;
    }

    if (!isRestored) {
      const nextLink = paginationWrapper.querySelector('[data-next-page-link]');

      if (!nextLink) {
        // No more pages, hide pagination and exit
        paginationWrapper.style.display = 'none';
        return;
      }

      nextPageUrl = nextLink.getAttribute('href');
    }

    // Hide the standard pagination wrapper
    paginationWrapper.style.display = 'none';

    // Create a new sentinel element for intersection scroll detection
    sentinel = document.createElement('div');
    sentinel.id = 'infinite-scroll-sentinel';
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.style.padding = '40px 0';
    sentinel.style.textAlign = 'center';
    sentinel.style.width = '100%';
    sentinel.style.display = 'flex';
    sentinel.style.justifyContent = 'center';
    sentinel.style.alignItems = 'center';
    sentinel.style.clear = 'both';
    
    // SVG spinner matching Shopify Dawn design
    sentinel.innerHTML = `
      <div class="loading-overlay__spinner" style="display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.85); padding: 12px; border-radius: 50%; box-shadow: 0 2px 10px rgba(0,0,0,0.05); width: 52px; height: 52px;">
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 2.8rem; height: 2.8rem; animation: rotator 1.4s linear infinite;">
          <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" style="stroke: rgba(var(--color-foreground), 0.75); stroke-dasharray: 187; stroke-dashoffset: 0; transform-origin: center; animation: dash 1.4s ease-in-out infinite;"></circle>
        </svg>
      </div>
      <style>
        @keyframes rotator {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(270deg); }
        }
        @keyframes dash {
          0% { stroke-dashoffset: 187; }
          50% {
            stroke-dashoffset: 46.75;
            transform: rotate(135deg);
          }
          100% {
            stroke-dashoffset: 187;
            transform: rotate(450deg);
          }
        }
      </style>
    `;

    // Append the sentinel right after the product grid
    productGrid.after(sentinel);

    // Setup IntersectionObserver
    intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isLoading && nextPageUrl) {
          loadNextPage();
        }
      });
    }, {
      rootMargin: '0px 0px 400px 0px' // Load next page 400px before the user reaches the bottom
    });

    intersectionObserver.observe(sentinel);
    triggerProductCountUpdate();
    isRestored = false;
  }

  function loadNextPage() {
    if (isLoading || !nextPageUrl) return;
    isLoading = true;
    
    // Show spinner in sentinel
    if (sentinel) {
      sentinel.style.display = 'flex';
    }

    const currentUrl = nextPageUrl;

    fetch(currentUrl)
      .then(response => response.text())
      .then(htmlText => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        
        const newProductGrid = doc.getElementById('product-grid');
        const newPaginationWrapper = doc.querySelector('.pagination-wrapper');

        if (!newProductGrid) {
          isLoading = false;
          if (sentinel) sentinel.style.display = 'none';
          return;
        }

        const productGrid = document.getElementById('product-grid');
        
        // Append all new products
        const newProducts = Array.from(newProductGrid.querySelectorAll('li.grid__item'));
        
        newProducts.forEach((li) => {
          productGrid.appendChild(li);
        });

        // Initialize scroll animations for the new products if animations exist
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(productGrid);
        }

        // Re-process product badges for the newly loaded products
        if (typeof window.updateProductBadges === 'function') {
          window.updateProductBadges();
        }

        // Update the next page URL or remove infinite scroll if done
        if (newPaginationWrapper) {
          const nextLink = newPaginationWrapper.querySelector('[data-next-page-link]');
          
          if (nextLink) {
            nextPageUrl = nextLink.getAttribute('href');
            isLoading = false;
          } else {
            nextPageUrl = null;
            if (sentinel) sentinel.remove();
            triggerProductCountUpdate();
          }
        } else {
          nextPageUrl = null;
          if (sentinel) sentinel.remove();
          triggerProductCountUpdate();
        }

        saveInfiniteScrollState();
      })
      .catch(error => {
        console.error('Error loading next page:', error);
        isLoading = false;
        if (sentinel) sentinel.style.display = 'none';
      });
  }

  function init() {
    const isBackForward = isBackForwardNavigation();
    const stateKey = `infinite-scroll:${window.location.pathname}${window.location.search}`;
    let restored = false;

    if (isBackForward) {
      try {
        const savedState = JSON.parse(sessionStorage.getItem(stateKey));
        if (savedState && savedState.html) {
          const productGrid = document.getElementById('product-grid');
          if (productGrid) {
            productGrid.innerHTML = savedState.html;
            nextPageUrl = savedState.nextPageUrl;
            isRestored = true;
            restored = true;

            // Restore scroll position immediately and with sequential timeouts
            window.scrollTo(0, savedState.scrollPosition);
            setTimeout(() => {
              window.scrollTo(0, savedState.scrollPosition);
            }, 50);
            setTimeout(() => {
              window.scrollTo(0, savedState.scrollPosition);
            }, 200);
            setTimeout(() => {
              window.scrollTo(0, savedState.scrollPosition);
            }, 500);
          }
        }
      } catch (e) {
        console.error('Error restoring infinite scroll state:', e);
      }
    }

    if (!restored) {
      // Clear the saved state for this page if it's a fresh visit
      try {
        sessionStorage.removeItem(stateKey);
      } catch (e) {}
    }

    setupInfiniteScroll();
    triggerProductCountUpdate();

    // Set up MutationObserver to re-initialize when filters/sorting change
    const targetContainer = document.getElementById('ProductGridContainer');
    if (targetContainer && !containerObserver) {
      containerObserver = new MutationObserver(() => {
        isRestored = false;
        nextPageUrl = null;
        setupInfiniteScroll();
        triggerProductCountUpdate();
      });
      containerObserver.observe(targetContainer, { childList: true, subtree: false });
    }
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
